import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, Backdrop, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import loadergif from './loader.gif';
import { useAppSelector, useAppDispatch } from '@application/store/useStore';
import { forceHideLoader } from '@application/features/common/loadingSlice';
const Loader = () => {
    const { isLoading, startTime } = useAppSelector((state) => state.loading);
    const dispatch = useAppDispatch();
    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        if (isLoading) {
            setShowLoader(true);
        }
        else {
            // Add a small delay before hiding the loader to prevent flickering
            const timeout = setTimeout(() => {
                setShowLoader(false);
            }, 150);
            return () => clearTimeout(timeout);
        }
    }, [isLoading]);
    // Handle timeout for long-running requests
    useEffect(() => {
        if (isLoading && startTime) {
            const timeout = setTimeout(() => {
                // Force hide loader after 1 minutes
                dispatch(forceHideLoader());
            }, 60000); // 1 minutes timeout
            return () => clearTimeout(timeout);
        }
    }, [isLoading, startTime, dispatch]);
    return showLoader ? (_jsx(Backdrop, { open: showLoader, sx: {
            color: (theme) => theme.palette.common.white,
            backdropFilter: 'blur(20px)',
            zIndex: 7000,
            backgroundColor: (theme) => alpha(theme.palette.common.black, 0.2)
        }, children: _jsx(Box, { component: 'img', src: loadergif, alt: 'Loading...', sx: { width: { xs: 300, sm: 400, md: '30%' }, height: 'auto' } }) })) : null;
};
export default Loader;
